<script setup lang="ts">
import { onMounted } from "vue";
import {useVisitorData} from '@fingerprintjs/fingerprintjs-pro-vue-v3';

const {data, error, isLoading, getData} = useVisitorData(
  {extendedResult: true},
  {immediate: false}
);

onMounted(() => {
  console.log(`✨ RAM Unify v${import.meta.env.RAM_APP_VERSION}`);
});
</script>

<template>
  <div class="h-full w-full font-inter" @click='getData({ignoreCache: true})'>
    <router-view />
  </div>
</template>
